import { IPagamento } from "../types/proposta";
import { moneyToNumber } from "./propostaMappers";

export function formatPagamentoParcelas(pagamento: IPagamento): string {
  const total = moneyToNumber(pagamento.valor);
  const parcelas =
    Number.parseInt(String(pagamento.qtd_parcelas ?? "").trim(), 10) || 1;

  const valorTotalFormatado =
    pagamento.valor && String(pagamento.valor).includes("R$")
      ? pagamento.valor
      : total.toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        });

  if (!total) {
    return `${valorTotalFormatado} em ${parcelas}x`;
  }

  const valorParcela = total / parcelas;
  const parcelaFormatada = valorParcela.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

  return `${valorTotalFormatado} em ${parcelas}x ${parcelaFormatada}`;
}
